import { useState } from "react";
import { RemoveExceptionsGroupDialogProps } from "~/components/exceptions/RemoveExceptionsGroupDialog";

export function useRemoveExceptionsGroupDialog(
  params: RemoveExceptionsGroupDialogProps,
) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { onClose } = params;
  const { onRemove, exceptionMrns, successMessage, errorMessage } =
    params.payload;

  const handleRemoveExceptionsGroupClick = async () => {
    setIsLoading(true);
    try {
      await onRemove({ exceptionMrns, successMessage, errorMessage });
    } finally {
      setIsLoading(false);
      await onClose();
    }
  };

  const handleClose = async () => {
    await onClose();
  };

  return {
    handleRemoveExceptionsGroupClick,
    handleClose,
    exceptionMrns,
    isLoading,
  };
}
